module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h10"
  }, [_c('a', {
    attrs: {
      "id": "a29"
    }
  }), _vm._v("Part 1: The Past")]), _vm._v(" "), _c('h2', {
    staticClass: "h20"
  }, [_c('a', {
    attrs: {
      "id": "ncx87"
    }
  }), _c('a', {
    attrs: {
      "id": "a30"
    }
  }), _vm._v("Chapter 1")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("The night my life changed, I hunched at the desk in my dark bedroom and turned on my computer tablet, illuminating a crucifix on the wall. Mom and Dad gave me the enormous bronze cross when I was seven years old. Every night Jesus gazed down at me with a bloody, mournful face. His crown of thorns seemed to sink deeper into his head if I stared at it long enough. I turned so I couldn’t see the accusing savior anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Within minutes, I’d hacked into an illegal chat room that looked promising with a surprisingly near Internet Portal address. I typed my usual question.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Serene1: I’m not normal. Can anyone help me?")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("FemmeJim: No help for you.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Serene1: What’s going to happen to me?")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Outcast: Banishment, if you’re serious. If not, this is no place for straights to play.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Enigma462: Let’s go to another chat, I’m not in the mood for this.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("I watched as names disappeared, and put a fist to my forehead. This always happened.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("But for once, there was another name left in the room.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Dawn360: What’s it like to live in a normal town?")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("I sat up straighter, wide-eyed and breathless. Finally!")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Serene1: It’s okay, but would be a lot better if I were normal, too. When did you get banished?")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Dawn360: I was born here.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Serene1: How is that possible in a gay community?")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Dawn360: You’re funny. I have two dads and a surrogate mom.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Serene1: So are you normal? I mean, straight.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Dawn360: No, not straight or normal at all.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Serene1: What kind of gay are you? I mean, are you lesbian, bisexual, transgender, or something else? I’ve always thought it was weird that the government just calls all of those things ‘gay’.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Dawn360: Yeah, it doesn’t make much sense to me, either. I’m a lesbian, but a lot of times I do just say I’m gay.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Serene1: How old are you?")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Dawn360: 17")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Serene1: Me too. Which community do you live in?")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Dawn360: Community 17.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Serene1: Weird…I live less than a mile away, in the normal town Mapleville.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Serenity, why aren’t you in bed?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("At the sight of Mom bursting through the door, I wiped my tablet blank. “I was checking my homework.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Get some sleep. You’ve got a big day tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("I hurried to bed, pulling the covers to my chin despite the warm night, and stared at the ceiling, full of unexplainable feelings.")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("* * * *")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Jesus was sparkling in the morning as sunlight streamed into my room. Few other things covered the white walls, just a couple baby pictures and a framed, cross-stitched Bible verse.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Sometimes I wished I could paint the walls black and scrawl cryptic, glow-in-the-dark messages on them. Instead, I put on my school uniform: a white blouse and black skirt. I pulled on pantyhose without tearing them this time and groaned before slipping on black leather shoes. The shoes were uncomfortable as hell, but at least the heels weren’t any higher. According to my school, high heels made girls look inappropriate.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("I wandered down the hall to the kitchen, where my parents were eating breakfast.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Good morning, honey,” Dad said.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Hi,” I mumbled, feeling guilty about the night before.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Mom smiled. “So grumpy when you wake up; you’ve been that way ever since you were little.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("I grinned as I slid into my chair. “I never want to go to sleep, and then I never want to get up.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("After breakfast, I forced my long hair into order. I’d just taken out multiple braids the night before, so I really had to work at it with leave-in conditioner and a pick, letting it hang long and naturally curly. Then, like every morning, Dad walked me to school on the way to his job in the office at the Mapleville Church of Jesus. He was a political organizer.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Have a good day, dear,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Thanks, love you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("As I walked through the body scanners, I finally had a chance to reminisce about the night before. A swarm of identically dressed girls, and boys who all wore white shirts and black pants, streamed past. Boring.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("But this Dawn360 person…I wondered what she looked like.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Serenity!” A tall redhead with caramel skin dodged through the crowds.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Hey, Zenith.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Zenith started talking about something, but the person online filled my mind…I couldn’t believe someone who’d been born in a gay community didn’t seem demonic at all. It was so weird.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Did you hear me? Did you study for sociology?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Oh, yeah. Sorry, Z.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Let me know if the test is bad.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("I nodded and walked into my first class, US History, as the bell rang.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Today we’re going to talk about separation of church and state,” Mr. Eluto said as he paced the front of the room. He was already sweating; he was famous for it. Behind his desk, the usual enormous, blank computer screen was mounted on the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("I pulled my tablet out of my backpack, tempted to break into chat rooms instead of taking notes, but it wasn’t worth the risk. Instead, I forced all thoughts of the night before away, watching Mr. Eluto’s bald head gleam under the lights.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“When our government was first formed, the founding fathers knew that to get the agreement of all people—even the godless—they would have to make some compromises,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Everyone else in the room began typing furiously on their own tablets. I keyed random phrases in multiple fonts and colors.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Freedom of religion was very important to the establishment of democracy. But as time passed, many of our nation’s leaders realized this separation was only necessary if no religion was different from any other. Since we know there is only one true God, there can be no compromises. Once the old separation law was abolished, The United States of America finally became, officially, a Christian nation.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Amen,” I said. I could always get away with talking in class if I said something religious.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Amen,” others murmured.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Yes, indeed.” Mr. Eluto mopped his face with a handkerchief and walked to his desk to type on a keyboard there. The giant computer screen behind him lit up. “This web site goes into more detail about the history of the great leaders of The Family Protection Movement, which helped transform our nation into the Promised Land it was always meant to be.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("I hid a yawn behind my hand and checked the thesaurus on my own screen for synonyms to the word “boring.”")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("* * * *")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“You have twenty minutes,” Mrs. Navarro said in Sociology, passing out papers to the class.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("I’d been dreading this test, even though I knew all the answers. For one thing, Mrs. Navarro was the only ancient teacher who still made us write everything by hand like we were in freaking elementary school. For another, Sociology was one of the classes I had to fake my way through the most. I filled out my answers quickly, trying not to think about them too much.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("1. When was The Divide established? "), _c('span', {
    staticClass: "t6"
  }, [_vm._v("During Civil War 2")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("2. Which tactics were used to round up homosexuals who were unwilling to relocate? "), _c('span', {
    staticClass: "t6"
  }, [_vm._v("Tear gas, anthrax, AIDS injections, night raids, warrants, threats to their normal families.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("3. What percentage of homosexuals moved to designated Gay Communities voluntarily? "), _c('span', {
    staticClass: "t6"
  }, [_vm._v("72% after the California Conflict, which had high casualties to both gay and normal people.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("4. Who established The Divide? "), _c('span', {
    staticClass: "t6"
  }, [_vm._v("The Family Protection Movement")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("5. True or False: Homosexuals meet all the criteria to be classified as domestic terrorists. "), _c('span', {
    staticClass: "t6"
  }, [_vm._v("True")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Twenty questions of this and finally an essay:")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("21. Discuss the reasons Americans are better off now that gays have been separated from normal citizens.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("I swallowed and wrote: "), _c('span', {
    staticClass: "t6"
  }, [_vm._v("Normal people are now free to live without the homosexual agenda shoved down their throats. Sending homosexuals to Gay Communities is the best way to let them destroy themselves without compromising our nation’s values.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("I couldn’t write any more without throwing up. I put my head on the desk until class was over.")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("* * * *")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("That night, I sat in bed with a blanket over my head, hiding my tablet’s glow. I’d gotten into some chat rooms, but couldn’t find anyone to talk to. I wondered if I dared find the girl I’d chatted with the night before, but she was probably just a government spy pretending to be a lesbian anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("A private message popped up on my screen.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Dawn360: Hi. Where did you go last night?")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("I clenched the tablet, heart beating faster. This could be a trap. My every word and move could be monitored right now. Probably was. I shouldn’t trust a faceless person online; my parents had told me that since I learned to read.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("But I also had problems I couldn’t tell anyone else about, and was going to end up banned no matter what. I might as well take the risk.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Serene1: Sorry, my mom busted into the room. She just thought I was doing homework, though.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Dawn360: I thought maybe you were a straight person pretending to be gay.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Serene1: I thought maybe you were a spy about to break down my door and arrest me. Or a creepy old guy.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Dawn360: Great, now I’m laughing, and I’ll probably wake my dads up.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Serene1: I can’t believe you actually want to chat with someone from a normal town.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Dawn360: I just wanted to talk to someone different; I didn’t know who I’d meet. But I don’t have anything against straight people. My brother Adam is straight and left for a normal college last fall. He’s only allowed to visit us for one weekend this summer.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Serene1: So now I know you have a brother named Adam, and I still don’t know your real name.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Dawn360: It’s Dawn. Not so creative with the screen names, huh?")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Serene1: It’s cool, my name’s Serenity.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Dawn360: LOL!")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("I peeked out from under my blanket to make sure my door was still shut.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Serene1: You’re the first person I’ve ever been able to talk to about this.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Dawn360: It must be weird having to hide who you are all the time. How do you get away with it?")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Serene1: Well, in 7th grade a boy asked me to date him, and I said yes because I thought I had no other choice. But all we really did was pass notes in school and go to one dance, and then he moved away. So now I just tell everyone I’m still in love with him, or that I don’t want to date until after high school because I’m saving myself for marriage.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Dawn360: ROFLMFAOLOL! Does that really work?")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Serene1: Surprisingly well.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("I chatted with Dawn until the sun turned my bedroom orange. I felt electrified. Even though I might be making a grave mistake, I’d never been able to talk to anyone like this in my life.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Serene1: What do you look like? I have dark hair, light brown skin, and blue eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Dawn360: I can send you a picture later. Can you send me a pic so I can envision my late-night straight-world chat buddy?")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_vm._v("Serene1: Sure.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("I combed out the tangles in my hair and snapped a picture of myself on the sunny side of the room using my photo app. After e-mailing it, I put the tablet on silent mode and stashed it in my black backpack so my parents wouldn’t hear anything if I received any messages.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("After Dad walked to school with me, though, I couldn’t resist checking my inbox.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("A picture of the most beautiful girl I’d ever seen had appeared there. The subject line bore seven digits and the phrase: "), _c('span', {
    staticClass: "t6"
  }, [_vm._v("Call Me.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df3fe5c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006.vue
// module id = 69
// module chunks = 0